import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface mutateProps {
  projectId: string;
  taskId: string;
  data: any
}

const mutateUpdateQualityCheck = async ({projectId, taskId, data}: mutateProps) => {
  return await axiosAuth.put(`${PROJECT_API}/${projectId}/tasks/${taskId}/quality-checks`, data);
};

const useUpdateQualityCheckMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateUpdateQualityCheck,
    ...queryParams,
  });

export default useUpdateQualityCheckMutation;
